module.exports = __webpack_public_path__ + "assets/img/10.b9a1024b.png";